import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-builder-required-validation-error',
  templateUrl: './form-builder-required-validation-error.component.html',
})
export class FormBuilderRequiredValidationErrorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
